import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { getCustomersQueryKey } from "modules/customers/lib/customersQuery"
import { DataResponse, UpsertCustomerBodySchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof UpsertCustomerBodySchema>>

type Props = {
  onSuccess?: () => void
}

export function useCreateCustomerMutation({ onSuccess }: Props = {}) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: z.infer<typeof UpsertCustomerBodySchema>) => {
      const response = await axios.post<Response>(`/customers`, {
        ...data,
        clientId: data.clientId != null ? String(data.clientId) : data.clientId,
      })

      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getCustomersQueryKey() })

      onSuccess?.()
    },
  })
}
